import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackMapInteraction } from './tracking/trackMapInteraction';
import { IJsonQuery } from '../../../../../packages/api-models/common/json_query';
import { IApplicationState } from '../../../../common/types/redux';
import { toggleIsFirstMapInteraction } from '../../../actions';
import { selectIsFirstMapInteraction } from '../../../selectors';

export function useTrackMapInteraction() {
  const dispatch = useDispatch();
  const jsonQuery = useSelector<IApplicationState, IJsonQuery>(state => state.filters.jsonQuery);
  const isFirstMapInteraction = useSelector<IApplicationState, boolean>(selectIsFirstMapInteraction);

  return React.useCallback(() => {
    if (isFirstMapInteraction) {
      dispatch(toggleIsFirstMapInteraction(false));
      trackMapInteraction(jsonQuery);
    }
  }, [isFirstMapInteraction, jsonQuery]);
}
